/**
 * @fileoverview DO NOT USE ANYTHING FROM THIS FILE
 *
 * @deprecated This file is deprecated and should not be used by future developers.
 * All exports from this file are considered legacy code and are scheduled for removal.
 *
 * @warning Using any exports from this file may result in:
 * - Inconsistent theming across the application
 * - Breaking changes without notice
 * - Performance issues
 * - Maintenance difficulties
 *
 * @alternative Please use the official theming system from @mentimeter/content-ui/ThemeProvider instead.
 * Refer to the design system documentation for proper theming patterns.
 *
 * @todo This file should be removed once all dependencies have been migrated to the new theming system.
 *
 * @author Legacy code - Do not extend or modify
 * @since This file is frozen and will not receive updates
 */

import {
  blue500,
  gray1300,
  gray200,
  green700,
  green200,
  coral500,
  purple200,
  whiteAlpha500,
  whiteAlpha800,
  whiteAlpha900,
  whiteBase,
  themes,
  whiteAlpha1000,
  coral300,
  colors,
} from '@mentimeter/ragnar-colors';
import type { Colors } from '@mentimeter/ragnar-dsc';

/**
 * @deprecated DO NOT USE - This type is deprecated and will be removed.
 * Use the official theming types from @mentimeter/content-ui/ThemeProvider instead.
 */
export type ThemeT =
  | 'balloon'
  | 'brand'
  | 'dark'
  | 'green'
  | 'greenDark'
  | 'greenLight'
  | 'pattern'
  | 'patternGreen'
  | 'patternGreenCTA'
  | 'patternYellowCTA'
  | 'patternPurpleCTA'
  | 'pink'
  | 'pinkLight'
  | 'plain'
  | 'purple'
  | 'purpleDark'
  | 'purpleLight'
  | 'shade'
  | 'yellow';

/**
 * @deprecated DO NOT USE - This type is deprecated and will be removed.
 * Use the official theming types from @mentimeter/content-ui/ThemeProvider instead.
 */
// Define a mapped type for CONTENT_THEME
type ContentThemeType = {
  [K in ThemeT]: { colors: Colors };
};

/**
 * @deprecated DO NOT USE - This interface is deprecated and will be removed.
 * Use the official theming interfaces from @mentimeter/content-ui/ThemeProvider instead.
 */
export interface CustomContentThemeType {
  theme?:
    | {
        colors: ThemeT;
      }
    | undefined;
}

/**
 * @deprecated DO NOT USE - This constant is deprecated and will be removed.
 *
 * @warning This theme configuration is legacy code and should not be used in new development.
 * It may contain inconsistent styling, performance issues, and will not receive updates.
 *
 * @alternative Use the official theming system from @mentimeter/content-ui/ThemeProvider instead.
 * Refer to the design system documentation for proper theming patterns.
 *
 * @example
 * // DON'T DO THIS:
 * // import { CONTENT_THEME } from './Theme';
 *
 * // DO THIS INSTEAD:
 * // import { useTheme } from '@mentimeter/ragnar-dsc';
 * // const theme = useTheme();
 */
// Update CONTENT_THEME to use the mapped type
export const CONTENT_THEME: ContentThemeType = {
  ...themes,
  dark: { colors: { ...themes.dark.colors, bg: gray1300 } },
  brand: {
    colors: {
      ...themes.primary.colors,
      borderPrimaryWeakest: whiteAlpha500,
    },
  },
  yellow: {
    colors: {
      ...themes.notice.colors,
      borderPrimaryWeakest: whiteAlpha900,
    },
  },
  green: {
    colors: {
      ...themes.positive.colors,
      borderPrimaryWeakest: whiteAlpha500,
    },
  },
  greenLight: {
    colors: {
      ...themes.neutral.colors,
      bg: green200,
      borderPrimaryWeakest: whiteAlpha800,
    },
  },
  greenDark: {
    colors: {
      ...themes.primary.colors,
      bg: green700,
      borderPrimaryWeakest: whiteAlpha500,
    },
  },
  pink: {
    colors: {
      ...themes.notice.colors,
      bg: coral500,
      borderPrimaryWeakest: whiteAlpha800,
    },
  },
  pinkLight: {
    colors: {
      ...themes.neutral.colors,
      bg: coral300,
      borderPrimaryWeakest: whiteAlpha900,
    },
  },
  purple: {
    colors: {
      ...themes.info.colors,
      borderPrimaryWeakest: whiteAlpha500,
      text: whiteBase,
      textWeak: whiteAlpha1000,
    },
  },
  purpleLight: {
    colors: {
      ...themes.neutral.colors,
      bg: purple200,
      borderPrimaryWeakest: whiteAlpha800,
    },
  },
  purpleDark: {
    colors: {
      ...themes.info.colors,
      borderPrimaryWeakest: whiteAlpha500,
      bg: gray1300,
      text: whiteBase,
      textWeak: whiteAlpha1000,
    },
  },
  plain: {
    colors: {
      ...themes.neutral.colors,
      bg: gray200,
      primary: blue500,
    },
  },
  shade: {
    colors: {
      ...themes.neutral.colors,
      bg: gray200,
      primary: blue500,
    },
  },
  balloon: {
    colors: {
      ...themes.neutral.colors,
      bg: colors.negativeWeak,
      borderPrimaryWeakest: whiteAlpha900,
    },
  },

  pattern: { ...themes.positive },
  patternGreen: { ...themes.positive },
  patternGreenCTA: { ...themes.positive },
  patternYellowCTA: { ...themes.positive },
  patternPurpleCTA: { ...themes.positive },
};
